import React from "react";
import { Image, Responsive, Grid, Header, GridRow } from "semantic-ui-react";
import { sliderArrowRight, sliderArrowLeft } from "../assets/Assets";
import Slider from "react-slick";
import { mainIp } from "../API/API";

class SliderNavLandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.dickref = React.createRef();
    this.slider = [];
  }

  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }

  renderInDesktop() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true
    };
    return (
      <div
        align="center"
        style={{
          width: "100%",
          marginBottom: "120px"
        }}
        className="marginTop"
      >
        <div>
          <Header
            as="h2"
            className="title"
            style={{
              color: "#5aa7d1",
              fontSize: "40px",
              textAlign: "left",
              fontFamily: "Merriweather",
              fontWeight: "bold",
              marginLeft: "-14px",
              marginBottom: "40px"
            }}
          >
            Amenidades
          </Header>
          <Grid>
            <Grid.Column width={5}>
              <Grid>
                <Grid.Row>
                  <div
                    style={{
                      fontSize: "18px",
                      fontFamily: "Lato",
                      fontWeight: 300,
                      textAlign: "left",
                      lineHeight: "20px"
                    }}
                    dangerouslySetInnerHTML={{
                      __html: this.props.amenities
                    }}
                  />
                </Grid.Row>

                <Grid.Row>
                  <div className="Sbutton">
                    <Image
                      src={sliderArrowLeft}
                      style={{ cursor: "pointer" }}
                      width={30}
                      height={30}
                      onClick={this.previous}
                      className="SButtonNav"
                    />
                    <Image
                      src={sliderArrowRight}
                      style={{ cursor: "pointer" }}
                      width={30}
                      height={30}
                      onClick={this.next}
                      className="SButtonNav"
                    />
                  </div>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column width={11}>
              <Slider ref={c => (this.slider = c)} {...settings}>
                {this.props.slider.map((data, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "20.5rem",
                        display: "flex",
                        justifyContent: "left",
                        alignSelf: "left",
                        alignContent: "left",
                        textAlign: "left",
                        marginRight: "3rem"
                      }}
                      onClick={() => {}}
                    >
                      <div>
                        <Image
                          src={mainIp + data.img.result}
                          className="amenitiesSlider"
                        />
                      </div>
                      <div
                        style={{
                          marginLeft: "1.5rem",
                          textAlign: "left"
                        }}
                      >
                        <Header
                          as="h2"
                          style={{
                            color: "#023552",
                            marginTop: "8px",
                            maxHeight: "5rem",
                            fontSize: "26px",
                            overflow: "hidden"
                          }}
                        >
                          {data.title}
                        </Header>
                        <p
                          style={{
                            fontSize: "15px",
                            marginTop: "10px",
                            fontFamily: "Lato",
                            lineHeight: "25px",
                            fontWeight: 300,
                            maxHeight: "7rem",
                            overflow: "hidden"
                        
                          }}
                        >
                          {data.desc}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }

  renderInTablet() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true
    };
    return (
      <div
        align="center"
        style={{
          width: "100%",
          marginBottom: "120px",
          padding: "0 5px"
        }}
        className="marginTop"
      >
        <div>
          <Header
            as="h2"
            className="title"
            style={{
              color: "#5aa7d1",
              fontSize: "40px",
              textAlign: "left",
              fontFamily: "Merriweather",
              fontWeight: "bold",
              marginLeft: "-14px",
              marginBottom: "40px"
            }}
          >
            Amenidades
          </Header>
          <Grid>
            <Grid.Column width={5}>
              <Grid>
                <Grid.Row>
                  <div
                    style={{
                      fontSize: "18px",
                      fontFamily: "Lato",
                      fontWeight: 300,
                      textAlign: "left",
                      lineHeight: "20px"
                    }}
                    dangerouslySetInnerHTML={{
                      __html: this.props.amenities
                    }}
                  />
                </Grid.Row>

                <Grid.Row>
                  <div className="Sbutton">
                    <Image
                      src={sliderArrowLeft}
                      style={{ cursor: "pointer" }}
                      width={30}
                      height={30}
                      onClick={this.previous}
                      className="SButtonNav"
                    />
                    <Image
                      src={sliderArrowRight}
                      style={{ cursor: "pointer" }}
                      width={30}
                      height={30}
                      onClick={this.next}
                      className="SButtonNav"
                    />
                  </div>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column width={11}>
              <Slider ref={c => (this.slider = c)} {...settings}>
                {this.props.slider.map((data, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "20.5rem",
                        display: "flex",
                        justifyContent: "left",
                        alignSelf: "left",
                        alignContent: "left",
                        textAlign: "left",
                        marginRight: "3rem"
                      }}
                      onClick={() => {}}
                    >
                      <div>
                        <Image
                          src={mainIp + data.img.result}
                          className="amenitiesSlider"
                        />
                      </div>
                      <div
                        style={{
                          textAlign: "left",
                          width: "210px"
                        }}
                      >
                        <Header
                          as="h2"
                          style={{
                            color: "#023552",
                            marginTop: "8px",
                            fontSize: "1.7rem",
                            overflow: "hidden",
                            maxHeight: "4rem"
                          }}
                        >
                          {data.title}
                        </Header>
                        <p
                          style={{
                            fontSize: "13px",
                            marginTop: "10px",
                            fontFamily: "Lato",
                            lineHeight: "25px",
                            fontWeight: 300,
                            overflow: "hidden",
                            maxHeight: "11rem"
                          }}
                        >
                          {data.desc}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }

  renderInMobile() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true
    };
    return (
      <div
        align="center"
        style={{
          width: "100%"
        }}
        className="marginTop"
      >
        <div
          style={{
            marginBottom: "40px",
            padding: "0 30px"
          }}
        >
          <Header
            as="h2"
            className="title marginBottom"
            style={{
              color: "#5aa7d1",
              fontSize: "1.5rem",
              textAlign: "left",
              fontFamily: "Merriweather",
              fontWeight: "bold",
              marginLeft: "-14px"
            }}
          >
            Amenidades
          </Header>
          <Grid columns={1} centered>
            <Grid.Column>
              <Grid>
                <Grid.Row>
                  <div
                    style={{
                      fontSize: "1rem",
                      fontFamily: "Lato",
                      fontWeight: 300,
                      textAlign: "left",
                      lineHeight: "20px"
                    }}
                    dangerouslySetInnerHTML={{
                      __html: this.props.amenities
                    }}
                  />
                </Grid.Row>

                <Grid.Row>
                  <div className="Sbutton">
                    <div>
                      <Image
                        src={sliderArrowLeft}
                        style={{ cursor: "pointer" }}
                        width={30}
                        height={30}
                        onClick={this.previous}
                        className="SButtonNav"
                      />
                    </div>
                    <div>
                      <Image
                        src={sliderArrowRight}
                        style={{ cursor: "pointer" }}
                        width={30}
                        height={30}
                        onClick={this.next}
                        className="SButtonNav"
                      />
                    </div>
                  </div>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column>
              <Slider ref={c => (this.slider = c)} {...settings}>
                {this.props.slider.map((data, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "left",
                        alignSelf: "left",
                        alignContent: "left",
                        textAlign: "left",
                        marginRight: "3rem"
                      }}
                      onClick={() => {}}
                    >
                      <div>
                        <Image
                          src={mainIp + data.img.result}
                          style={{ width: "100%", height: "200px" }}
                          className="amenitiesSlider"
                        />
                      </div>
                      <div
                        style={{
                          marginLeft: "15px",
                          textAlign: "left"
                        }}
                      >
                        <Header
                          as="h2"
                          style={{
                            color: "#023552",
                            marginTop: "8px",
                            fontSize: "1.5rem",
                            overflow: "hidden",
                            maxHeight: "4rem"
                          }}
                        >
                          {data.title}
                        </Header>
                        <p
                          style={{
                            fontSize: "15px",
                            marginTop: "10px",
                            fontFamily: "Lato",
                            lineHeight: "23px",
                            fontWeight: 300,
                            overflow: "hidden",
                            maxHeight: "11.5rem"
                          }}
                        >
                          {data.desc}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}

export default SliderNavLandingPage;
